
import { Cart, CartItem, ClientInfo } from "../Caisse/Interfaces"

export const addToCart = (
    product: any,
    client: string,
    quantity: number,
    immat: string,
    warehouse?: string,
    clientInfo?: ClientInfo,
    order_id? : any
) => {
    const savedCart = localStorage.getItem('cart');
    let cart: Cart = savedCart ? JSON.parse(savedCart) : { client: '', items: [], clientInfo: null, order_id : null };

    // Create product cart item
    const productItem: CartItem = {
        cartItemId: `${product.crm?.id ?? ''}-${Date.now()}`,
        id: product.crm?.id ?? 'N/A',
        lineId: '',
        articleName: product.crm?.label ?? product.tecdoc?.articleName ?? 'N/A',
        quantity: quantity,
        immat: immat,
        warehouse: warehouse,
        brandName: product.tecdoc?.brandName,
        ref: product.tecdoc?.articleNo || product.crm?.ref,
        price_ttc: Number(product.crm?.price_ttc || 0),
        price_min: product.crm?.price_min || 0,
        product: product
    };

    let newItems = [...cart.items, productItem];

    if (product.consigne?.rowid) {
        const consigneItem: CartItem = {
            cartItemId: `${product.consigne.rowid}-${Date.now()}`,
            id: product.consigne.rowid,
            lineId: '',
            articleName: product.consigne.label || 'Consigne',
            quantity: quantity, 
            immat: immat,
            brandName: product.tecdoc?.brandName,
            ref: product.ref,
            warehouse: warehouse,
            price_ttc: Number(product.consigne.price_ttc || 0),
            price_min: 0,
            consigne: {
                rowid: product.consigne.rowid,
                ref: product.consigne.ref,
                label: product.consigne.label,
                price: product.consigne.price,
                price_ttc: product.consigne.price_ttc
            },
            parentCartItemId: productItem.cartItemId // Link consigne to product
        };
        newItems = [...newItems, consigneItem];
    }

    cart = {
        client: client,
        items: newItems,
        clientInfo: clientInfo || cart.clientInfo,
        order_id : order_id
    };

    localStorage.setItem('cart', JSON.stringify(cart));
    window.dispatchEvent(new Event('cart-updated'));

    return cart;
};